/* kh-mischpalette.js — Konfigurator für sections/kh-mischpalette.liquid.
 *
 * Zustand: n Plätze (5 oder 10), je Platz ein Artikel und eine Zahl Kartons.
 * Die Kartons summieren sich immer auf genau die Palettengröße (42); beim
 * Wechsel der Platzzahl wird gleichmäßig neu verteilt, gewählte Sorten
 * bleiben stehen. Kein Warenkorb: abgeschickt wird eine Anfrage über das
 * Shopify-Kontaktformular, Begründung im Kopf der Sektion.
 */
(function () {
  'use strict';

  var FARBEN = ['#007F62', '#2E5FA8', '#C27A2C', '#8250B8', '#B8364F',
                '#3F8C3B', '#1A8BA3', '#A3851C', '#5F5C55', '#C4568C'];

  function init(root) {
    var daten = [], texte = {};
    try { daten = JSON.parse(root.querySelector('[data-kh-mp-daten]').textContent); } catch (e) { daten = []; }
    try { texte = JSON.parse(root.querySelector('[data-kh-mp-texte]').textContent); } catch (e) { texte = {}; }

    var KARTON = parseInt(root.dataset.karton, 10) || 240;
    var KARTONS = parseInt(root.dataset.kartons, 10) || 42;
    var PREISE = root.dataset.preise === '1';
    var sprache = (root.dataset.sprache || 'de').indexOf('en') === 0 ? 'en-GB' : 'de-DE';
    var geld = new Intl.NumberFormat(sprache, { style: 'currency', currency: root.dataset.waehrung || 'EUR' });
    var zahl = new Intl.NumberFormat(sprache);
    var nachId = {};
    daten.forEach(function (p) { nachId[p.id] = p; });

    var el = {
      wahl: root.querySelectorAll('[data-kh-mp-anzahl]'),
      stapel: root.querySelector('[data-kh-mp-stapel]'),
      slots: root.querySelector('[data-kh-mp-slots]'),
      auswahl: root.querySelector('[data-kh-mp-auswahl]'),
      auswahlTitel: root.querySelector('[data-kh-mp-auswahl-titel]'),
      suche: root.querySelector('[data-kh-mp-suche]'),
      marken: root.querySelector('[data-kh-mp-marken]'),
      zSorten: root.querySelector('[data-kh-mp-z-sorten]'),
      zKartons: root.querySelector('[data-kh-mp-z-kartons]'),
      zDosen: root.querySelector('[data-kh-mp-z-dosen]'),
      zPreis: root.querySelector('[data-kh-mp-z-preis]'),
      zSpar: root.querySelector('[data-kh-mp-z-spar]'),
      hinweis: root.querySelector('[data-kh-mp-hinweis]'),
      form: root.querySelector('[data-kh-mp-form]'),
      text: root.querySelector('[data-kh-mp-text]'),
      senden: root.querySelector('[data-kh-mp-senden]')
    };

    var zustand = { n: 5, plaetze: [], aktiv: 0, marke: '', suche: '' };

    /* Handy (04.11.2026): die Auswahl zeigte alle rund 100 Sorten als große
       Karten, die Seite war 31.000 px lang. Unter 640 px erst 24, „Weitere
       anzeigen“ holt die nächsten. Suche und Marke wirken auf alle. */
    var SCHRITT = window.matchMedia('(max-width: 639px)').matches ? 24 : Infinity;
    var zeigen = SCHRITT;

    /* Marken ohne Rücksicht auf Groß-/Kleinschreibung: der Shop führt
       „PABLO“ und „Pablo“, „Skruf“ und „skruf“ als Hersteller -- das waren
       doppelte Knöpfe. Angezeigt wird die Schreibweise, die weder ganz klein
       noch ganz groß ist, sonst die erste. */
    function markenSchluessel(m) { return String(m || '').trim().toLowerCase(); }
    var markenName = {};
    daten.forEach(function (p) {
      var k = markenSchluessel(p.m), alt = markenName[k];
      var gemischt = p.m !== p.m.toLowerCase() && p.m !== p.m.toUpperCase();
      if (!alt || (gemischt && (alt === alt.toLowerCase() || alt === alt.toUpperCase()))) markenName[k] = p.m;
    });

    function verteilen(n, alt) {
      var basis = Math.floor(KARTONS / n), rest = KARTONS % n, neu = [];
      for (var i = 0; i < n; i++) {
        neu.push({ id: alt && alt[i] ? alt[i].id : null, kartons: basis + (i < rest ? 1 : 0) });
      }
      return neu;
    }

    function t(k, werte) {
      var s = texte[k] || '';
      /* Platzhalter [name] statt {{ name }}: Shopifys t-Filter wuerde die
         geschweiften schon beim Rendern ersetzen. */
      if (werte) Object.keys(werte).forEach(function (w) { s = s.split('[' + w + ']').join(werte[w]); });
      return s;
    }

    function summeKartons() { return zustand.plaetze.reduce(function (a, p) { return a + p.kartons; }, 0); }
    function gefuellt() { return zustand.plaetze.filter(function (p) { return p.id; }).length; }
    function ersterLeerer() {
      for (var i = 0; i < zustand.plaetze.length; i++) if (!zustand.plaetze[i].id) return i;
      return -1;
    }

    /* ── Palette: 42 Kartons als Stapel, je Platz eine Farbe ── */
    function zeichneStapel() {
      var html = '';
      zustand.plaetze.forEach(function (p, i) {
        for (var k = 0; k < p.kartons; k++) {
          html += '<span class="kh-mp__karton' + (p.id ? '' : ' kh-mp__karton--leer') + (i === zustand.aktiv ? ' kh-mp__karton--aktiv' : '') +
                  '" style="--kh-mp-farbe:' + FARBEN[i % FARBEN.length] + '"></span>';
        }
      });
      el.stapel.innerHTML = html;
    }

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    /* ── Plätze ── */
    function zeichnePlaetze() {
      var frei = KARTONS - summeKartons();
      el.slots.innerHTML = zustand.plaetze.map(function (p, i) {
        var a = p.id ? nachId[p.id] : null;
        var farbe = FARBEN[i % FARBEN.length];
        var kopf = '<span class="kh-mp__slot-nr" style="--kh-mp-farbe:' + farbe + '">' + (i + 1) + '</span>';
        var menge = '<div class="kh-mp__menge">' +
          '<button type="button" data-kh-mp-minus="' + i + '" aria-label="' + esc(t('weniger')) + '"' + (p.kartons <= 1 ? ' disabled' : '') + '>−</button>' +
          '<span><b>' + p.kartons + '</b> ' + esc(t('kartons')) + '<small>' + zahl.format(p.kartons * KARTON) + ' ' + esc(t('dosen')) + '</small></span>' +
          '<button type="button" data-kh-mp-plus="' + i + '" aria-label="' + esc(t('mehr')) + '"' + (frei <= 0 && !stehlbar(i) ? ' disabled' : '') + '>+</button>' +
          '</div>';
        if (!a) {
          return '<li class="kh-mp__slot kh-mp__slot--leer' + (i === zustand.aktiv ? ' is-aktiv' : '') + '">' +
            '<button type="button" class="kh-mp__slot-wahl" data-kh-mp-slot="' + i + '">' + kopf +
            '<span class="kh-mp__slot-plus" aria-hidden="true">+</span>' +
            '<span class="kh-mp__slot-text">' + esc(i === zustand.aktiv ? t('slot_aktiv') : t('slot_waehlen')) + '</span></button>' +
            menge + '</li>';
        }
        var preis = PREISE && a.pal ? '<span class="kh-mp__slot-preis">' + geld.format(a.pal / 100) + ' ' + esc(t('je_dose')) + '</span>' : '';
        return '<li class="kh-mp__slot' + (i === zustand.aktiv ? ' is-aktiv' : '') + '">' +
          '<button type="button" class="kh-mp__slot-wahl" data-kh-mp-slot="' + i + '">' + kopf +
          (a.bild ? '<img src="' + esc(a.bild) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="kh-mp__slot-plus"></span>') +
          '<span class="kh-mp__slot-text"><small>' + esc(a.m) + '</small><b>' + esc(a.t) + '</b>' + preis + '</span></button>' +
          '<button type="button" class="kh-mp__slot-weg" data-kh-mp-weg="' + i + '" aria-label="' + esc(t('entfernen')) + '">×</button>' +
          menge + '</li>';
      }).join('');
    }

    /* Ein Karton mehr geht auch bei voller Palette, wenn ein anderer Platz
       mehr als einen Karton hat -- er gibt dann einen ab. */
    function stehlbar(ausser) {
      return zustand.plaetze.some(function (p, j) { return j !== ausser && p.kartons > 1; });
    }

    /* ── Auswahl ── */
    function zeichneMarken() {
      var marken = Object.keys(markenName).sort(function (a, b) { return a.localeCompare(b, 'de'); });
      el.marken.innerHTML = '<button type="button" data-kh-mp-marke="" class="' + (zustand.marke ? '' : 'is-an') + '">' + esc(t('alle')) + '</button>' +
        marken.map(function (k) { return '<button type="button" data-kh-mp-marke="' + esc(k) + '" class="' + (zustand.marke === k ? 'is-an' : '') + '">' + esc(markenName[k]) + '</button>'; }).join('');
    }

    function zeichneAuswahl() {
      var q = zustand.suche.toLowerCase();
      var liste = daten.filter(function (p) {
        if (zustand.marke && markenSchluessel(p.m) !== zustand.marke) return false;
        if (q && (p.t + ' ' + p.m + ' ' + (p.sku || '')).toLowerCase().indexOf(q) < 0) return false;
        return true;
      });
      var belegt = {};
      zustand.plaetze.forEach(function (p, i) { if (p.id) belegt[p.id] = i + 1; });
      if (!liste.length) { el.auswahl.innerHTML = '<li class="kh-mp__keine">' + esc(t('keine')) + '</li>'; return; }
      var gesamt = liste.length;
      liste = liste.slice(0, zeigen);
      el.auswahl.innerHTML = liste.map(function (p) {
        var platz = belegt[p.id];
        var spar = PREISE && p.kar > p.pal ? Math.round((1 - p.pal / p.kar) * 100) : 0;
        return '<li><button type="button" class="kh-mp__artikel' + (platz ? ' is-gewaehlt' : '') + '" data-kh-mp-artikel="' + p.id + '"' + (platz ? ' aria-pressed="true"' : '') + '>' +
          (platz ? '<span class="kh-mp__artikel-platz" style="--kh-mp-farbe:' + FARBEN[(platz - 1) % FARBEN.length] + '">' + platz + '</span>' : '') +
          '<span class="kh-mp__artikel-bild">' + (p.bild ? '<img src="' + esc(p.bild) + '" alt="" width="120" height="120" loading="lazy">' : '') + '</span>' +
          '<small>' + esc(p.m) + '</small><b>' + esc(p.t) + '</b>' +
          '<span class="kh-mp__artikel-fuss">' +
            (PREISE && p.pal ? '<span class="kh-mp__artikel-preis">' + geld.format(p.pal / 100) + '<em>' + esc(t('je_dose')) + '</em></span>' : '') +
            (spar > 0 ? '<span class="kh-mp__artikel-spar">−' + spar + ' %</span>' : '') +
          '</span>' +
          '<span class="kh-mp__artikel-lager' + (p.lager ? ' is-ok' : '') + '">' + esc(p.lager ? t('auf_lager') : t('nachbestellbar')) + '</span>' +
          '</button></li>';
      }).join('') +
      (gesamt > liste.length ? '<li class="kh-mp__mehr-zeile"><button type="button" class="kh-knopf kh-knopf--sekundaer kh-mp__mehr" data-kh-mp-mehr>' +
        esc((t('weitere') || 'Weitere [n] von [rest] anzeigen').split('[n]').join(Math.min(SCHRITT, gesamt - liste.length)).split('[rest]').join(gesamt - liste.length)) + '</button></li>' : '');
    }

    /* ── Zusammenfassung + Anfrage ── */
    function zeichneSumme() {
      var f = gefuellt(), n = zustand.n, k = summeKartons();
      var kartonsGewaehlt = 0, preis = 0, sparen = 0;
      zustand.plaetze.forEach(function (p) {
        if (!p.id) return;
        var a = nachId[p.id];
        kartonsGewaehlt += p.kartons;
        if (PREISE && a.pal) {
          preis += p.kartons * KARTON * a.pal;
          if (a.kar > a.pal) sparen += p.kartons * KARTON * (a.kar - a.pal);
        }
      });
      el.zSorten.textContent = f + ' / ' + n;
      el.zKartons.textContent = kartonsGewaehlt + ' / ' + KARTONS;
      el.zDosen.textContent = zahl.format(kartonsGewaehlt * KARTON);
      if (el.zPreis) el.zPreis.textContent = preis ? geld.format(preis / 100) : '—';
      if (el.zSpar) {
        el.zSpar.hidden = !(sparen > 0);
        el.zSpar.textContent = sparen > 0 ? t('spar', { betrag: geld.format(sparen / 100) }) : '';
      }
      var fertig = f === n && k === KARTONS;
      var hinweis = !f ? t('hinweis_leer') : (f < n ? t('hinweis_sorten', { anzahl: n - f }) : (k !== KARTONS ? t('hinweis_kartons') : t('hinweis_fertig')));
      el.hinweis.textContent = hinweis;
      el.hinweis.classList.toggle('is-fertig', fertig);
      if (el.senden) el.senden.disabled = !fertig;
      if (el.text) el.text.value = anfrageText(preis);
      root.classList.toggle('is-fertig', fertig);
    }

    function anfrageText(preis) {
      var zeilen = ['Mischpalette: ' + zustand.n + ' Sorten, ' + KARTONS + ' Kartons à ' + KARTON + ' = ' + zahl.format(KARTONS * KARTON) + ' Dosen', ''];
      zustand.plaetze.forEach(function (p, i) {
        if (!p.id) return;
        var a = nachId[p.id];
        var z = (i + 1) + '. ' + (a.sku ? a.sku + ' · ' : '') + a.t + ' — ' + p.kartons + ' Kartons = ' + zahl.format(p.kartons * KARTON) + ' Dosen';
        if (PREISE && a.pal) z += ' × ' + geld.format(a.pal / 100) + ' = ' + geld.format(p.kartons * KARTON * a.pal / 100);
        zeilen.push(z);
      });
      if (preis) zeilen.push('', 'Summe netto (Palettenpreis je Sorte): ' + geld.format(preis / 100));
      return zeilen.join('\n');
    }

    function alles() {
      zeichneStapel(); zeichnePlaetze(); zeichneAuswahl(); zeichneSumme();
      var p = zustand.plaetze[zustand.aktiv];
      if (el.auswahlTitel) el.auswahlTitel.textContent = p ? t('waehlen_fuer', { nr: zustand.aktiv + 1 }) : t('schritt_waehlen');
    }

    /* ── Ereignisse ── */
    Array.prototype.forEach.call(el.wahl, function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(b.dataset.khMpAnzahl, 10);
        if (n === zustand.n) return;
        zustand.n = n;
        zustand.plaetze = verteilen(n, zustand.plaetze);
        zustand.aktiv = Math.max(0, ersterLeerer());
        Array.prototype.forEach.call(el.wahl, function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        alles();
      });
    });

    el.slots.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.dataset.khMpSlot != null) {
        zustand.aktiv = parseInt(b.dataset.khMpSlot, 10);
        alles();
        var ziel = root.querySelector('#kh-mp-auswahl');
        if (ziel && window.matchMedia('(max-width: 899px)').matches) ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (b.dataset.khMpWeg != null) {
        var i = parseInt(b.dataset.khMpWeg, 10);
        zustand.plaetze[i].id = null;
        zustand.aktiv = i;
        alles();
      } else if (b.dataset.khMpMinus != null) {
        var m = parseInt(b.dataset.khMpMinus, 10);
        if (zustand.plaetze[m].kartons <= 1) return;
        zustand.plaetze[m].kartons -= 1;
        /* Der frei gewordene Karton geht an den kleinsten anderen Platz,
           damit die Palette voll bleibt. */
        var ziel2 = -1;
        zustand.plaetze.forEach(function (p, j) { if (j !== m && (ziel2 < 0 || p.kartons < zustand.plaetze[ziel2].kartons)) ziel2 = j; });
        if (ziel2 >= 0) zustand.plaetze[ziel2].kartons += 1;
        alles();
      } else if (b.dataset.khMpPlus != null) {
        var pl = parseInt(b.dataset.khMpPlus, 10);
        if (summeKartons() >= KARTONS) {
          /* Den Karton gibt der größte andere Platz ab. */
          var spender = -1;
          zustand.plaetze.forEach(function (p, j) { if (j !== pl && p.kartons > 1 && (spender < 0 || p.kartons > zustand.plaetze[spender].kartons)) spender = j; });
          if (spender < 0) return;
          zustand.plaetze[spender].kartons -= 1;
        }
        zustand.plaetze[pl].kartons += 1;
        alles();
      }
    });

    el.auswahl.addEventListener('click', function (e) {
      if (e.target.closest('[data-kh-mp-mehr]')) { zeigen += SCHRITT; zeichneAuswahl(); return; }
      var b = e.target.closest('[data-kh-mp-artikel]');
      if (!b) return;
      var id = parseInt(b.dataset.khMpArtikel, 10);
      var schon = -1;
      zustand.plaetze.forEach(function (p, i) { if (p.id === id) schon = i; });
      if (schon >= 0) {
        /* Zweiter Klick auf eine gewählte Sorte nimmt sie wieder heraus. */
        zustand.plaetze[schon].id = null;
        zustand.aktiv = schon;
      } else {
        var ziel = zustand.plaetze[zustand.aktiv] && !zustand.plaetze[zustand.aktiv].id ? zustand.aktiv : ersterLeerer();
        if (ziel < 0) ziel = zustand.aktiv;
        zustand.plaetze[ziel].id = id;
        var naechster = ersterLeerer();
        zustand.aktiv = naechster >= 0 ? naechster : ziel;
      }
      alles();
    });

    el.marken.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kh-mp-marke]');
      if (!b) return;
      zustand.marke = b.dataset.khMpMarke;
      zeigen = SCHRITT;
      zeichneMarken(); zeichneAuswahl();
    });

    if (el.suche) el.suche.addEventListener('input', function () { zustand.suche = el.suche.value.trim(); zeigen = SCHRITT; zeichneAuswahl(); });

    if (el.form) el.form.addEventListener('submit', function (e) {
      if (gefuellt() !== zustand.n || summeKartons() !== KARTONS) { e.preventDefault(); return; }
      el.text.value = anfrageText(zustand.plaetze.reduce(function (a, p) {
        var x = p.id ? nachId[p.id] : null;
        return a + (x && PREISE && x.pal ? p.kartons * KARTON * x.pal : 0);
      }, 0));
    });

    zustand.plaetze = verteilen(zustand.n);
    zeichneMarken();
    alles();
  }

  function start() { document.querySelectorAll('[data-kh-mp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
